import { render, staticRenderFns } from "./VehicleCategoriesPage.vue?vue&type=template&id=6c4e284e"
import script from "./VehicleCategoriesPage.vue?vue&type=script&lang=ts"
export * from "./VehicleCategoriesPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports